// store/reducers/manufactureReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    manufacturingOrders: [],
    tempManufacturingOrders: [],
    manufacturingIsLoading: false,
    manufacturingPagination: {
        total: 0,
        page: 1,
        pages: 1,
    },
    productionStats: {},
    efficiencyStats: {},
    availableRawMaterials: [],
    availableRawMaterialsLoading: false,
};

const manufactureSlice = createSlice({
    name: "manufacturing",
    initialState,
    reducers: {
        setManufacturingOrders(state, action) {
            state.manufacturingOrders = action.payload;
            state.manufacturingIsLoading = false;
        },
        setTempManufacturingOrders(state, action) {
            state.tempManufacturingOrders = action.payload;
        },
        setManufacturingPagination(state, action) {
            state.manufacturingPagination = action.payload;
        },
        setProductionStats(state, action) {
            state.productionStats = action.payload;
        },
        setEfficiencyStats(state, action) {
            state.efficiencyStats = action.payload;
        },
        setAvailableRawMaterials(state, action) {
            state.availableRawMaterials = action.payload;
            state.availableRawMaterialsLoading = false;
        },
        setAvailableRawMaterialsLoading(state, action) {
            state.availableRawMaterialsLoading = action.payload;
        },
        addManufacturingOrder(state, action) {
            state.manufacturingOrders.unshift(action.payload);
            state.tempManufacturingOrders.unshift(action.payload);
        },
        updateManufacturingOrder(state, action) {
            const { index, order } = action.payload;
            if (state.manufacturingOrders[index]) {
                state.manufacturingOrders[index] = order;
                state.tempManufacturingOrders[index] = order;
            }
        },
        deleteManufacturingOrder(state, action) {
            const { index } = action.payload;
            state.manufacturingOrders.splice(index, 1);
            state.tempManufacturingOrders.splice(index, 1);
        },
        setManufacturingIsLoading(state, action) {
            state.manufacturingIsLoading = action.payload;
        },
    },
});

export const {
    setManufacturingOrders,
    setTempManufacturingOrders,
    setManufacturingPagination,
    setProductionStats,
    setEfficiencyStats,
    setAvailableRawMaterials,
    setAvailableRawMaterialsLoading,
    addManufacturingOrder,
    updateManufacturingOrder,
    deleteManufacturingOrder,
    setManufacturingIsLoading,
} = manufactureSlice.actions;

export default manufactureSlice.reducer;

